<div class="flex flex-col gap-4" #soccerMatchesContainer>
  @if(competitionMatchesPast()!== null && competitionMatchesPast()!.length > 0
  ){
  <!--  -->
  <div class="mt-3 font-roboto-500 text-18 max-sm:text-14">
    {{ "LastMatches" | translate }}
  </div>
  @for (match of competitionMatchesPast(); track match.Id; let i = $index) {
  <!--  -->
  @if (isNextMatches(match.Date) && isFirstMatchOfDay(competitionMatchesPast()!,
  i)) {
  <app-date-label [matchDate]="match.Date" />
  }

  <app-match-by-competition-item [data]="match" />
  } } @else {
  <!--  -->
  @if(!fetchComputed().isLoading){

  <app-no-result message="NotAvalaibleInformation" />
  } }
</div>

<div #scrollTrigger style="height: 1px"></div>

<!-- Case Loading -->
@if(fetchComputed().isLoading){
<app-skeleton-matches-list />
}

<!-- Case Error -->
@if((fetchComputed().isError && !fetchComputed().isLoading) ){
<app-no-result message="NotAvalaibleInformation" />
}
